var map = {
	"./press-releases.de-CH.json": 1602,
	"./press-releases.de-DE.json": 1603,
	"./press-releases.en-CA.json": 1604,
	"./press-releases.en-GB.json": 1605,
	"./press-releases.en-IN.json": 1606,
	"./press-releases.en-ME.json": 1607,
	"./press-releases.en-US.json": 1608,
	"./press-releases.es-EM.json": 1609,
	"./press-releases.es-ES.json": 1610,
	"./press-releases.fr-BE.json": 1611,
	"./press-releases.fr-CA.json": 1612,
	"./press-releases.fr-CH.json": 1613,
	"./press-releases.nl-BE.json": 1614,
	"./press-releases.nl-NL.json": 1615,
	"./press-releases.pl-PL.json": 1616,
	"./press-releases.pt-BR.json": 1617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1601;